import { FC } from "react"
import { Mail } from "lucide-react"

import If from "../../../../if"
import Badge from "../../../../badge"
import { LinkBtn } from "../../../../buttons"
import { formatDateTimeFromTimestamp } from "../../../../../utils"
import { SubscriptionEmailLog } from "../../../../../../types"

interface Props {
  log: SubscriptionEmailLog
  onSelect: (id: string) => void
  connectorVisible?: boolean
}

const EngagementEmailLog: FC<Props> = ({
  log,
  onSelect,
  connectorVisible = true
}) => {
  if (!log) return null

  const { status, timestamp, email_id } = log

  return (
    <div className="md:flex items-center justify-between py-3 md:max-w-3xl">
      <div className="flex items-center">
        <div className="rounded-full bg-neutral-500 p-3 relative">
          <Mail color="#fff" />
          {connectorVisible && (
            <div className="absolute top-12 left-6 mt-1 -ml-[1px] w-0 h-4 border-2 border-neutral-400"></div>
          )}
        </div>
        <div className="ml-4">
          <If
            condition={!!email_id}
            then={
              <LinkBtn
                theme="alt"
                text="base"
                className="hover:text-primary-500"
                borderClassName="border-0 border-dashed border-neutral-400 border-b rounded-none"
                paddingOff
                onClick={() => onSelect(email_id)}
              >
                <span className="font-bold">Rate alert</span>
              </LinkBtn>
            }
            else={<span className="font-bold">Rate alert</span>}
          />
          &nbsp;sent to lead
          <span className="ml-2">
            {status === "0" && <Badge.Info>Unopened</Badge.Info>}
            {status === "1" && <Badge.Info>Sent</Badge.Info>}
            {status === "2" && <Badge.Danger>Opened</Badge.Danger>}
            {status === "3" && <Badge.Success>Clicked</Badge.Success>}
          </span>
        </div>
      </div>

      <div className="text-neutral-400 ml-16 md:ml-0 mt-2 md:mt-0">
        {formatDateTimeFromTimestamp(timestamp, "LL/dd/yyyy 'at' hh:mm:ss a")}
      </div>
    </div>
  )
}

export default EngagementEmailLog
